import React from "react";
import { useFormContext } from "react-hook-form";
import { CreateAdminFormFields } from "Shared/types/Admins";
import { LocationsSelectFormField } from "Components/Shared/FormComponents/LocationsSelectFormField/LocationsSelectFormField";

const LocationsSelect = () => {
  const { setValue } = useFormContext<CreateAdminFormFields>();

  return (
    <LocationsSelectFormField
      setLocationsFieldValue={locations => setValue("locations", locations)}
      selectAllOption={true}
    />
  );
};

export default LocationsSelect;
